import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "voice-summary-initials" }
const _hoisted_2 = { class: "d-flex flex-wrap align-center" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "slider-thumb-label" }
const _hoisted_6 = { class: "slider-thumb-label" }
const _hoisted_7 = { class: "pt-0" }
const _hoisted_8 = {
  key: 0,
  class: "card-action-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AudioPlayer = _resolveComponent("AudioPlayer")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0 pa-2 card",
    color: "background",
    "bg-color": "background",
    variant: "elevated",
    elevation: "4",
    density: "compact"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        class: "ma-0 pa-0 card-content",
        "bg-color": "background",
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
        density: "compact",
        autocomplete: "off"
      }, {
        default: _withCtx(() => [
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_item, {
                key: 0,
                class: "voice-summary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = true))
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_v_avatar, {
                    size: "40",
                    rounded: "lg",
                    color: "primary",
                    class: "mr-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.voiceInitials), 1)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.name || 'New Voice'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, { class: "text-truncate" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.providerKey || 'No provider') + " · " + _toDisplayString(_ctx.selectedVoiceName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 1,
                class: "pt-0 pb-2 voice-summary-text"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedVoiceLabelsEntries.slice(0, 3), ([key, value]) => {
                      return (_openBlock(), _createBlock(_component_v_chip, {
                        key: `${key}-${value}`,
                        size: "small",
                        variant: "tonal",
                        class: "mr-2 mb-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(value), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (_ctx.responseFormat)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          size: "small",
                          variant: "outlined",
                          class: "mr-2 mb-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.responseFormat), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_v_list, {
                class: "ma-0 pa-0 card-content",
                "bg-color": "background",
                density: "compact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Select an audio-capable provider for this voice."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [15]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.providerKey,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.providerKey) = $event)),
                          _ctx.providerChanged
                        ],
                        items: _ctx.audioProviderKeys,
                        label: "Provider",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        rules: [() => !!_ctx.providerKey || 'Provider is required'],
                        readonly: !_ctx.isCopy
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules", "readonly"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Select a voice from the provider's available voices. Use Sync to refresh the list."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [16]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_autocomplete, {
                        modelValue: _ctx.selectedVoiceId,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedVoiceId) = $event)),
                          _ctx.voiceSelected
                        ],
                        items: _ctx.voices,
                        "item-title": "name",
                        "item-value": "id",
                        label: "Provider Voices",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        disabled: !_ctx.providerKey,
                        loading: _ctx.voicesLoading,
                        readonly: _ctx.voicesLoading,
                        rules: [() => !!_ctx.selectedVoiceId || 'Provider voice is required']
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_Button, {
                            color: "primary",
                            buttonClass: "ml-n2",
                            click: _ctx.syncVoices,
                            disabled: _ctx.syncDisabled,
                            icon: "mdi-sync",
                            size: "x-large",
                            tooltip: "Sync Voices"
                          }, null, 8, ["click", "disabled"])
                        ]),
                        item: _withCtx(({ props, item }) => [
                          _createVNode(_component_v_list_item, _mergeProps(props, { title: undefined }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, _toDisplayString(item.raw.name ?? item.raw.id), 1),
                                  (item.raw.labels?.descriptive)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "x-small",
                                        class: "ml-2",
                                        color: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.raw.labels.descriptive), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  (item.raw.labels?.accent)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 1,
                                        size: "x-small",
                                        class: "ml-2",
                                        color: _ctx.accentChipColor(item.raw.labels.accent)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.raw.labels.accent), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    : _createCommentVNode("", true),
                                  (item.raw.labels?.gender)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 2,
                                        size: "x-small",
                                        class: "ml-2",
                                        color: _ctx.genderChipColor(item.raw.labels.gender)
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.raw.labels.gender), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        selection: _withCtx(({ item }) => [
                          _createElementVNode("span", null, _toDisplayString(item?.raw?.name ?? item?.raw?.id), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "loading", "readonly", "rules"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Alias name must be unique and will appear in voice lists."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [17]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.name) = $event)),
                        label: "Voice Alias",
                        class: "pt-2",
                        rules: _ctx.nameRules,
                        variant: "outlined",
                        density: "compact",
                        readonly: !_ctx.isCopy,
                        clearable: _ctx.isCopy
                      }, null, 8, ["modelValue", "rules", "readonly", "clearable"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Optional description of the voice."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [18]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.description,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.description) = $event)),
                        label: "Description",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Optional default audio format for this voice. Leave blank to use server default (mp3)."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-5 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [19]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.responseFormat,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.responseFormat) = $event)),
                        items: _ctx.responseFormatItems,
                        label: "Response Format (optional)",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        clearable: ""
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.showGlobalTooltips)
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            position: "top",
                            "max-width": "300",
                            text: "Optional default playback speed. Range 0.25–4.0."
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_icon, _mergeProps(props, {
                                size: "x-small",
                                class: "global-tooltip-icon mt-3 ml-n6"
                              }), {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode("mdi-information-outline")
                                ])),
                                _: 2,
                                __: [20]
                              }, 1040)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_row, {
                          class: "ma-0 pa-0",
                          dense: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "ma-0 pr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_slider, {
                                  class: "voice-slider ml-0",
                                  modelValue: _ctx.speedField,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.speedField) = $event)),
                                  color: "primary",
                                  "track-color": "secondary",
                                  min: 0.25,
                                  max: 4.0,
                                  step: 0.05,
                                  "track-size": 6,
                                  "thumb-size": 18,
                                  density: "compact"
                                }, {
                                  prepend: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createElementVNode("span", { class: "text-caption" }, "Speed", -1)
                                  ])),
                                  append: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(Number.isFinite(Number(_ctx.speedField)) ? Number(_ctx.speedField).toFixed(2) : '1'), 1)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.isElevenLabs)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.showGlobalTooltips)
                            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                key: 0,
                                position: "top",
                                "max-width": "300",
                                text: "Optional ElevenLabs voice settings."
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_icon, _mergeProps(props, {
                                    size: "x-small",
                                    class: "global-tooltip-icon mt-2 ml-n6"
                                  }), {
                                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                                      _createTextVNode("mdi-information-outline")
                                    ])),
                                    _: 2,
                                    __: [22]
                                  }, 1040)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_row, {
                              class: "ma-0 pa-0",
                              dense: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "ma-0 pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_slider, {
                                      class: "voice-slider ml-0",
                                      modelValue: _ctx.ttsStabilityField,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ttsStabilityField) = $event)),
                                      color: "primary",
                                      "track-color": "secondary",
                                      min: 0,
                                      max: 1,
                                      step: 0.05,
                                      "track-size": 6,
                                      "thumb-size": 18,
                                      density: "compact"
                                    }, {
                                      prepend: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createElementVNode("span", { class: "text-caption" }, "Stability", -1)
                                      ])),
                                      append: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(Number.isFinite(Number(_ctx.ttsStabilityField)) ? Number(_ctx.ttsStabilityField).toFixed(2) : '—'), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "ma-0 pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_slider, {
                                      class: "voice-slider",
                                      modelValue: _ctx.ttsSimilarityBoostField,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ttsSimilarityBoostField) = $event)),
                                      color: "primary",
                                      "track-color": "secondary",
                                      min: 0,
                                      max: 1,
                                      step: 0.05,
                                      "track-size": 6,
                                      "thumb-size": 18,
                                      density: "compact"
                                    }, {
                                      prepend: _withCtx(() => _cache[24] || (_cache[24] = [
                                        _createElementVNode("span", { class: "text-caption" }, [
                                          _createTextVNode("Similarity"),
                                          _createElementVNode("br"),
                                          _createTextVNode("Boost")
                                        ], -1)
                                      ])),
                                      append: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(Number.isFinite(Number(_ctx.ttsSimilarityBoostField)) ?
                        Number(_ctx.ttsSimilarityBoostField).toFixed(2) : '—'), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "ma-0 pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_slider, {
                                      class: "voice-slider ml-0",
                                      modelValue: _ctx.ttsStyleField,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ttsStyleField) = $event)),
                                      color: "primary",
                                      "track-color": "secondary",
                                      min: 0,
                                      max: 1,
                                      step: 0.05,
                                      "track-size": 6,
                                      "thumb-size": 18,
                                      density: "compact"
                                    }, {
                                      prepend: _withCtx(() => _cache[25] || (_cache[25] = [
                                        _createElementVNode("span", { class: "text-caption" }, "Style", -1)
                                      ])),
                                      append: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(Number.isFinite(Number(_ctx.ttsStyleField)) ?
                        Number(_ctx.ttsStyleField).toFixed(2) : '—'), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "ma-0 pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_switch, {
                                      class: "ml-2",
                                      modelValue: _ctx.ttsUseSpeakerBoostField,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ttsUseSpeakerBoostField) = $event)),
                                      color: "primary",
                                      "base-color": "primary",
                                      density: "compact",
                                      inset: ""
                                    }, {
                                      prepend: _withCtx(() => _cache[26] || (_cache[26] = [
                                        _createElementVNode("span", { class: "text-caption" }, "Use Speaker Boost", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedVoiceLabelsEntries.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 1,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-caption mb-1" }, "Voice Labels", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedVoiceLabelsEntries, ([k,v], idx) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: k + idx
                              }, [
                                _createVNode(_component_v_chip, {
                                  size: "x-small",
                                  class: "mr-2 mb-1",
                                  color: "success"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(k) + ": " + _toDisplayString(v), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.testText,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.testText) = $event)),
                        label: "Try a short phrase to test this voice",
                        class: "pt-2",
                        variant: "outlined",
                        density: "compact",
                        clearable: "",
                        onKeydown: _withKeys(_withModifiers(_ctx.testVoice, ["prevent"]), ["enter"])
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            disabled: !_ctx.canTest,
                            icon: "",
                            variant: "text",
                            density: "compact",
                            size: "x-large",
                            color: "secondary",
                            class: "ml-0 mr-1",
                            onClick: _ctx.testVoice
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          (_ctx.hasTestAudio)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                icon: "",
                                variant: "text",
                                density: "compact",
                                size: "x-large",
                                color: "warning",
                                class: "ml-0",
                                onClick: _ctx.clearTest
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, { icon: "mdi-close" })
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onKeydown"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.finalPreviewUrl)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 2,
                        class: _normalizeClass(_ctx.showGlobalTooltips ? 'my-0 ml-6 mr-0 pa-0' : 'ma-0 pa-0'),
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AudioPlayer, {
                            src: _ctx.finalPreviewUrl,
                            "canv-height": 40,
                            "canv-width": 300,
                            "bar-color": _ctx.audioColor,
                            "show-controls": true,
                            "auto-play": _ctx.hasTestAudio
                          }, null, 8, ["src", "bar-color", "auto-play"])
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.show]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { density: "compact" }, {
            default: _withCtx(() => [
              (_ctx.show)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    color: "primary",
                    class: "mr-4",
                    disabled: _ctx.saveDisabled,
                    click: _ctx.updateVoice,
                    icon: "mdi-check-bold",
                    size: "x-large",
                    tooltip: "Save Voice",
                    density: "compact"
                  }, null, 8, ["disabled", "click"]))
                : _createCommentVNode("", true),
              (_ctx.show && !_ctx.isCopy)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    color: "primary",
                    class: "mr-4",
                    click: _ctx.initiateDeleteVoice,
                    icon: "mdi-trash-can-outline",
                    size: "x-large",
                    tooltip: "Delete Voice",
                    density: "compact"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "mx-auto",
                icon: _ctx.show ? 'mdi-chevron-up' : 'mdi-chevron-down',
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.show = !_ctx.show)),
                density: "compact"
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.waiting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.actionMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteConfirmationDialog,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showDeleteConfirmationDialog) = $event)),
        title: "Confirm Voice Deletion",
        message: "Are you sure you want to delete this voice?",
        itemName: _ctx.name,
        itemType: "voice",
        loading: _ctx.waiting,
        onConfirm: _ctx.confirmVoiceDelete,
        onCancel: _ctx.cancelDeleteVoice
      }, null, 8, ["modelValue", "itemName", "loading", "onConfirm", "onCancel"])
    ]),
    _: 1
  }))
}